import React, { useState, useEffect } from 'react';
import { authProvider } from '../../../services/Security';
import { CircularProgress, Grid, Tab, Tabs } from '@material-ui/core';
import '../../../scss/UVP.scss';
import { RecurringReportCriteria } from './RecurringReportCriteria';
import { RecurringReportList } from './RecurringReportList';
import { DistrictInfoVService } from '../../../services/V2/padre';

export const RecurringReportTabs = ({ errorToast }) => {
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [operatorId, setOperatorId] = useState<any>();
    const [districtId, setDistrictId] = useState<any>();
    const [model, setModel] = useState()
    const [districtName, setDistrictName] = useState<any>("");
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data) {
                const data = JSON.parse(event.data);
                authProvider.setToken(data?.token);
                setOperatorId(data.operatorId);
                setDistrictId(data.districtId);
                setLoading(false)
            }
        };

        window.addEventListener('message', handleMessage);
      
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    useEffect(() => {
        setLoading(true)
        DistrictInfoVService.districtInfoVGetDistrictInfo(districtId)
            .then((x: any) => {
                setDistrictName(x.name);
                setLoading(false)
            })
            .catch((x) => { });
	}, 	[districtId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (tab: number) => {
        setSelectedTab(tab);
    };

    return (
        <React.Fragment>
            <Grid style={{ backgroundColor: 'white' }}>
                <Tabs
                    className='uvp-tab-bar'
                    style={{ backgroundColor: '#f5f5f5' }}
                    value={selectedTab}
                    onChange={(_, tab) => handleChange(tab)}
                    TabIndicatorProps={{ style: { background: '#3f8a3d', height: "4px" } }}>
                    <Tab
                        className='uvp-tabs'
                        label="Report Criteria"
                        style={{
                            backgroundColor: selectedTab === 0 ? 'white' : '#E0E0E0'
                        }} />
                    <Tab
                        className='uvp-tabs'
                        label="Output"
                        style={{
                            backgroundColor: selectedTab === 1 ? 'white' : '#E0E0E0'
                        }} />
                </Tabs>
                {selectedTab === 0 ?
                    <RecurringReportCriteria
                        model={model}
                        operatorId={operatorId}
                        districtId={districtId}
                        districtName={districtName}
                        submit={() => handleChange(1)}
                        setModel={setModel} 
                        errorToast={errorToast}
                        setLoading={setLoading}
                        loading={loading} /> :
                    <RecurringReportList
                        model={model} />
                }
                {loading && 
                    <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                }
            </Grid>
        </React.Fragment>
    );
};
